import "./Papier_dechire.css"

import React from 'react';
import { Link } from 'react-scroll';
import baniere from './assets/baniere.png'

function Papier_dechire(){
  return(
        <img src={baniere} className="img" alt="Bike" />
  )
}

export default Papier_dechire
